import React, { useEffect, useState } from 'react';

import { Box, Button, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CutRow from './CutRow';
import { addCut, updateCut, deleteCut, setEditHistoryFlag, setEditHistory } from '@modules/editor';
import '../../../../../../../resources/assets/styles/editor.scss';

function CutMenu({ setChangingList, videoDurationTime }) {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const cutList = useSelector((state) => state.editor.cutList);
    const editHistory = useSelector((state) => state.editor.editHistory);
    const editHistoryFlag = useSelector((state) => state.editor.editHistoryFlag);

    console.log('CutMenu render - cutList:', cutList);

    const handleCreateNewCut = () => {
        if (!Array.isArray(cutList) || cutList.length < 5) {
            let newCut;

            if (cutList.length > 0) {
                const lastCut = cutList[cutList.length - 1];

                newCut = {
                    from: lastCut.to + 10, // Start 10 seconds after the last cut's end
                    to: lastCut.to + 20,   // End 10 seconds after the start
                };
            } else {
                newCut = {
                    from: 0,              // Start from 0 if no cuts exist
                    to: 10,               // End after 10 seconds
                };
            }
            dispatch(addCut(newCut));
            dispatch(setEditHistoryFlag(1));
            dispatch(setEditHistory([...cutList, newCut]));
        }
    };

    const handleDeleteCut = (idx) => {
        dispatch(deleteCut(idx));
        dispatch(setEditHistoryFlag(1));
        let deletedCutList = cutList.filter((cut, index) => index !== idx);
        dispatch(setEditHistory(deletedCutList));
    };

    return (
        <Box className='cut-menu'>
            {cutList.length > 0 && cutList.map((el, idx) => (
                <Box key={`crop_${idx}`} className='cut-item'>
                    <Typography variant="body1" className='cut-label'>
                        {t('vod.manage.editor_tab.cut_region')} {idx + 1}
                    </Typography>
                    <Box className='cut-row-container'>
                        <CutRow idx={idx} el={el} setChangingList={setChangingList} videoDurationTime={videoDurationTime} />
                    </Box>
                    <IconButton
                        className='delete-button'
                        onClick={(e) => handleDeleteCut(idx)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Box>
            ))}
            {cutList.length < 5 && (
                <IconButton className="add-button" onClick={handleCreateNewCut}>
                    <AddIcon className="cut-menu__add-icon" />
                    <Typography variant="body1">{t('vod.manage.editor_tab.new_cut_region')}</Typography>
                </IconButton>
            )}
        </Box>
    );
}

export default CutMenu;
